
import { defineComponent, ref } from 'vue'

export default defineComponent({
    props: {
        count: {
            type: Number,
            default: 0
        }
    }, setup() {
        const filterId = ref('bubble-filter-12222')
        return { filterId }
    }
})
